var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificateLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 57,
    viewBox: "0 0 62 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9703 56.1006H9.07031",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9707 45.3904H49.8407V38.4604H25.7707V44.4104",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0703 45.3901V56.1001H56.0003V45.3901H45.3303",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 42.4004V56.1504",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.791 42.4004V56.1504",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0107 42.4004V56.1504",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4404 28.9704V18.1304H44.1204V23.8604L37.4404 23.6704",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1201 20.3901H50.2001L48.3701 22.9501L50.2001 26.0801H44.1201V20.3901Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56 56.1006H61.11",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3506 36.7705C28.1406 37.5605 28.2406 37.0205 28.2406 37.6205",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5902 37.8303C46.6458 36.6494 46.4542 35.4699 46.0276 34.3674C45.6011 33.2648 44.9489 32.2635 44.113 31.4276C43.277 30.5916 42.2757 29.9395 41.1732 29.5129C40.0706 29.0863 38.8911 28.8947 37.7102 28.9503H36.2402",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1 33.6605H33.41V1.25049H1V33.6605Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1 33.6606H33.11",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7502 6.31047L18.9202 5.29047L20.0102 7.42047L22.3702 7.87047L22.0002 10.2405L23.6502 11.9805L21.9602 13.6905L22.2602 16.0705L19.8902 16.4505L18.7402 18.5605L16.6002 17.4705L14.4302 18.5005L13.3302 16.3605L10.9702 15.9205L11.3402 13.5505L9.7002 11.8005L11.3902 10.1005L11.0802 7.72047L13.4502 7.33047L14.6002 5.23047L16.7502 6.31047Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8298 11.9003C18.8298 12.3279 18.7028 12.7459 18.465 13.1013C18.2272 13.4567 17.8893 13.7336 17.494 13.8968C17.0988 14.06 16.664 14.1022 16.2447 14.018C15.8254 13.9338 15.4406 13.7271 15.1389 13.424C14.8372 13.121 14.6323 12.7351 14.5501 12.3155C14.4678 11.8958 14.5121 11.4612 14.6771 11.0667C14.8421 10.6722 15.1205 10.3355 15.477 10.0994C15.8335 9.86328 16.2521 9.73828 16.6798 9.74026C16.963 9.74025 17.2433 9.7962 17.5049 9.90487C17.7664 10.0135 18.0038 10.1728 18.2036 10.3735C18.4034 10.5742 18.5615 10.8124 18.669 11.0744C18.7764 11.3364 18.8311 11.6171 18.8298 11.9003V11.9003Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4796 16.9307L9.34961 28.8107L12.9096 26.7307L15.0696 30.4207L16.8596 23.6307",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8594 23.7606L18.5494 30.4406L20.6594 26.8906L24.3294 29.0806L21.2494 16.9106",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4502 18.1104L16.8602 23.6304",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateLibrary);
export default __webpack_public_path__ + "static/media/certificate_library.2cae5f2b544bf3b57303715d0b192c55.svg";
export { ForwardRef as ReactComponent };